import { isEmpty } from 'lodash';
import { FileType } from 'src/app/shared/model/file-type';

export class ExportRequest {

    constructor(
        public readonly fileType: FileType,
        public readonly cron: string | null,
        public readonly fileName: string) { }

    isEmpty(): boolean {
        return isEmpty(this.fileType);
    }
}
